import { MapPin, Calendar, Clock, Users } from "lucide-react";
import { getEventStatus } from "@/lib/status";

export const EventCard = ({ event, onRsvp }) => {
  const status = getEventStatus(event.status);
  return (
    <div
      data-testid={`event-card-${event.slug}`}
      className="group bg-white border border-black/10 hover:border-ink transition-all duration-300 hover:-translate-y-1 hover:shadow-brutal flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {event.image ? (
          <img src={event.image} alt={event.title} loading="lazy"
            className="absolute inset-0 w-full h-full object-cover saturate-[.85] transition-[transform,filter] duration-700 group-hover:scale-105 group-hover:saturate-100" />
        ) : (
          <div className="absolute inset-0 bg-ink noise-bg flex items-center justify-center">
            <span className="font-display text-4xl uppercase text-cream/20">{event.city}</span>
          </div>
        )}
        <span className={`absolute top-4 left-4 text-[10px] font-bold tracking-[0.15em] uppercase px-3 py-1.5 ${status.badge}`}>
          {status.label}
        </span>
        <span className="absolute top-4 right-4 text-[10px] font-bold tracking-[0.15em] uppercase bg-cream text-ink px-3 py-1.5">
          {event.price_label || "Free"}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-flame">Roamies {event.city} · {event.event_type}</p>
        <h3 className="font-display text-2xl uppercase mt-2 leading-none">{event.title}</h3>
        <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs font-semibold text-ink/60">
          {(event.date_label || event.time_label) && (
            <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" />{event.date_label}{event.time_label ? ` · ${event.time_label}` : ""}</span>
          )}
          <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{event.city}</span>
          <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />{event.age_req} · Max {event.max_attendees}</span>
        </div>
        {event.description && <p className="mt-3 text-sm text-ink/65 leading-relaxed flex-1">{event.description}</p>}
        <button
          onClick={() => onRsvp && onRsvp(event)}
          data-testid={`event-rsvp-${event.slug}`}
          className="mt-5 w-full bg-ink hover:bg-flame text-cream h-12 font-bold uppercase tracking-widest text-xs transition-colors"
        >
          {status.cta}
        </button>
      </div>
    </div>
  );
};
